"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Will calculate the scrollTime via scrollDistance
 * @param distance Distance to scroll
 */
var getScrollTime = function (distance, speed) { return Math.pow(distance, (1 / 3)) / (speed / 29000); };
exports.default = getScrollTime;
//# sourceMappingURL=getScrollTime.js.map